import Cookies from 'quasar/src/plugins/Cookies.js';; // you need access to `ssrContext`

export default function getCookies()
/*ssrContext*/
{
  // const cookies = process.env.SERVER ? Cookies.parseSSR(ssrContext) : Cookies // otherwise we're on client
  // "cookies" is equivalent to the global import as in non-SSR build
  return Cookies;
}
export { getCookies };